<template><section><h3>图表介绍</h3>
<p>RadialBar，玉玦图。</p>
<h3>attrs</h3>
<table>
<thead>
<tr>
<th>属性名</th>
<th>类型</th>
<th>默认值</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>min</td>
<td>Number</td>
<td><code v-pre>0</code></td>
<td>最小值</td>
</tr>
<tr>
<td>max</td>
<td>Number</td>
<td><code v-pre>1</code></td>
<td>最大值</td>
</tr>
<tr>
<td>startAngle</td>
<td>Number</td>
<td>-90</td>
<td>起始角度</td>
</tr>
<tr>
<td>endAngle</td>
<td>Number</td>
<td>270</td>
<td>结束角度</td>
</tr>
<tr>
<td>radius</td>
<td>Number</td>
<td><code v-pre>0.8</code></td>
<td>外半径比例</td>
</tr>
<tr>
<td>innerRadius</td>
<td>Number</td>
<td><code v-pre>0</code></td>
<td>内半径比例</td>
</tr>
<tr>
<td>strokeBgcolor</td>
<td>String</td>
<td><code v-pre>#eee</code></td>
<td>背景圆弧的背景色</td>
</tr>
<tr>
<td>lineWidth</td>
<td>Number</td>
<td><code v-pre>5</code></td>
<td>弧线宽度</td>
</tr>
</tbody>
</table>
<h3>style</h3>
<p>组件中可以自定义 css 属性的元素如下表：</p>
<table>
<thead>
<tr>
<th>名称</th>
<th>基础类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>arc</td>
<td>线</td>
<td>弧线样式</td>
</tr>
<tr>
<td>arc:hover</td>
<td>线</td>
<td>弧线鼠标hover样式</td>
</tr>
</tbody>
</table>
</section></template><script>export default {components:{}}</script>